import React from "react";
const REACT_APP_PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;

function NewEmployee({ chart_data }) {
  const data = Array.isArray(chart_data) ? chart_data : [];

  if (!data.length) {
    return <div className="text-muted">No Data Available</div>;
  }

  return (
    <>
      {data.map((emp) => (
        <div key={emp.id} className="card shadow-none mb-2">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
              
              {/* Left Section */}
              <div className="d-flex align-items-start">

                {/* Avatar */}
                <img
                  src={
                    emp.userpic
                      ? `${REACT_APP_PINE_BASE_URL}/files/media/${emp.userpic}`
                      : "assets/img/users/default.jpg"
                  }
                  className="avatar avatar-xxl img-fluid me-3"
                  alt={emp.employee}
                />

                {/* User Details */}
                <div>
                  <div className="d-flex align-items-center flex-wrap mb-1">
                    <h6 className="fs-16 fw-semibold mb-0 me-2">
                      {emp.employee}
                    </h6>
                    <span className="badge bg-primary-transparent">
                      New Joiner
                    </span>
                  </div>

                  <p className="text-muted fs-13 mb-1">
                    {emp.designation} - Reporting {emp.reporting}
                  </p>

                  <p className="text-muted fs-13 mb-0 d-flex align-items-center">
                    <span className="avatar avatar-sm bg-success-transparent rounded-circle me-2">
                      <i className="ti ti-checklist fs-16"></i>
                    </span>
                    Previously at {emp.previous_company}
                  </p>
                </div>
              </div>

              {/* Right Section - Joining Date */}
              <div className="d-flex align-items-center">
                <i className="ti ti-calendar fs-16 me-2 text-primary"></i>
                <span className="fs-13 text-muted">
                  {new Date(emp.appointment_date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              </div>

            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default NewEmployee;